export function getDefectsDashboardData(startDate?: string, endDate?: string) {
  const params = new URLSearchParams()
  if (startDate) params.append('startDate', startDate)
  if (endDate) params.append('endDate', endDate)

  const queryString = params.toString()
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/reportsV2/defects-dashboard${
      queryString ? `?${queryString}` : ''
    }`,
  }
}

export function getDefectsDashboardByLocation(
  startDate?: string,
  endDate?: string,
) {
  const params = new URLSearchParams()
  if (startDate) params.append('startDate', startDate)
  if (endDate) params.append('endDate', endDate)

  const queryString = params.toString()
  return {
    method: 'GET',
    url: `${
      process.env.REACT_APP_ORIGIN
    }/reportsV2/defects-dashboard/by-location${
      queryString ? `?${queryString}` : ''
    }`,
  }
}

export function getDefectsDashboardByTechnician(
  isTechnicianFaultOnly: boolean,
  startDate?: string,
  endDate?: string,
) {
  const params = new URLSearchParams()
  if (startDate) params.append('startDate', startDate)
  if (endDate) params.append('endDate', endDate)
  if (isTechnicianFaultOnly) params.append('technicianFaultOnly', 'true')

  const queryString = params.toString()
  return {
    method: 'GET',
    url: `${
      process.env.REACT_APP_ORIGIN
    }/reportsV2/defects-dashboard/by-technician${
      queryString ? `?${queryString}` : ''
    }`,
  }
}
